var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"network"},[_c('img',{attrs:{"src":require("@/assets/network.png"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('no_network_favorite')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }